import i18n from "../../../i18n";
import React, { useState } from "react";
import { IconNote } from "@tabler/icons";
import {
  ActionIcon,
  Button,
  Group,
  Popover,
  Stack,
  Textarea,
  Tooltip,
} from "@mantine/core";

const BidNotesButton = ({
  description = "",
  internalRemark = "",
  onSave,
  disabled = false,
}) => {
  const [opened, setOpened] = useState(false);
  const [draftDescription, setDraftDescription] = useState(description || "");
  const [draftInternal, setDraftInternal] = useState(internalRemark || "");
  const [saving, setSaving] = useState(false);
  const hasNote = Boolean(
    (description && description.trim()) ||
      (internalRemark && internalRemark.trim()),
  );

  const open = () => {
    setDraftDescription(description || "");
    setDraftInternal(internalRemark || "");
    setOpened(true);
  };

  const save = async () => {
    if (!onSave) {
      setOpened(false);
      return;
    }
    setSaving(true);
    try {
      const ok = await onSave({
        description: draftDescription,
        internalRemark: draftInternal,
      });
      if (ok !== false) setOpened(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-end"
      withinPortal
      shadow="md"
      width={320}
    >
      <Popover.Target>
        <Tooltip
          label={
            hasNote
              ? i18n.t("payrollBid.notes.edit", "Bid notes")
              : i18n.t("payrollBid.notes.add", "Add note")
          }
          withArrow
          disabled={opened}
        >
          <ActionIcon
            className="bid-notes-btn"
            data-has-note={hasNote ? "true" : "false"}
            data-opened={opened ? "true" : "false"}
            size="xs"
            variant={hasNote ? "light" : "subtle"}
            color={hasNote ? "green" : "gray"}
            aria-label={i18n.t("payrollBid.notes.edit", "Bid notes")}
            disabled={disabled}
            onClick={(event) => {
              event.stopPropagation();
              if (opened) setOpened(false);
              else open();
            }}
          >
            <IconNote size={14} />
          </ActionIcon>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown
        onClick={(event) => event.stopPropagation()}
      >
        <Stack spacing="xs">
          <Textarea
            size="xs"
            minRows={2}
            label={i18n.t("payrollBid.description", "Description")}
            description={i18n.t(
              "payrollBid.descriptionHint",
              "Shown to the consultant",
            )}
            value={draftDescription}
            onChange={(event) => setDraftDescription(event.target.value)}
          />
          <Textarea
            size="xs"
            minRows={2}
            label={i18n.t("payrollBid.internalRemark", "Internal remark")}
            description={i18n.t(
              "payrollBid.internalRemarkHint",
              "Staff only. Not shown to the consultant",
            )}
            value={draftInternal}
            onChange={(event) => setDraftInternal(event.target.value)}
          />
          <Group position="right" spacing="xs">
            <Button
              size="xs"
              variant="default"
              onClick={() => setOpened(false)}
            >
              {i18n.t("Cancel")}
            </Button>
            <Button size="xs" loading={saving} onClick={save}>
              {i18n.t("Save", "Save")}
            </Button>
          </Group>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default BidNotesButton;
